export { BoatsCardsList } from './BoatsCardsList.component';
export type { BoatsCardsListProps } from './BoatsCardsList.props';
